/* eslint-disable react/prop-types */
import React from 'react';
import constants from '../app/constants';
import GenericButton from './GenericButton';
import IconButton from './IconButton';
import Price from './Price';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';

/**
 * @param props.id
 * @param props.isOpen
 * @param props.isConfirmed
 * @param props.confirmedSelection
 * @param props.isVisible
 * @param props.hasLearnMore
 * @param props.hasTooltip
 * @param props.handleLearnMore
 * @param props.handleEdit
 * @param props.isLearnMore
 * @param props.tooltipRef
 */
const Step = props => {
    const labels = useSelector(state => state.main.labels);
    const isInsuranceEnabled = useSelector(state => state.main.isInsuranceEnabled);
    const isInsuranceLoading = useSelector(state => state.main.isInsuranceLoading);
    const isLearnMoreModalOpen = useSelector(state => state.main.isLearnMoreModalOpen);
    const isPrescriptionModalOpen = useSelector(state => state.main.isPrescriptionModalOpen);
    const isPDModalOpen = useSelector(state => state.main.isPDModalOpen);
    const baseLensPackage = useSelector(state => state.main.baseLensPackage);
    const selectedPackage = useSelector(state => state.main.selectedPackage);
    const currentStep = useSelector(state => state.main.currentStep);
    const selectedPrescriptionObject = useSelector(state => state.main.selectedPrescriptionObject);
    const treatmentStepTitleInGvp = useSelector(state => state.main.treatmentStepTitleInGvp);
    const isGVP = useSelector(state => state.main.isGVP);

    const isAnyModalOpen = isPrescriptionModalOpen || isPDModalOpen || isLearnMoreModalOpen;

    const treatmentStepTitle =
        treatmentStepTitleInGvp && props.id === 'treatments'
            ? treatmentStepTitleInGvp
            : labels.steps[props.id].title;

    const getTitleOpacity = () => {
        let opacity = 1.0;

        if (constants.steps.length > 0) {
            const opacityStep = 100.0 / constants.steps.length;
            opacity = 1.0 - (constants.steps.indexOf(props.id) * opacityStep) / 100.0;
        }

        return opacity;
    };

    return props.isVisible === undefined || props.isVisible ? (
        <>
            <div
                id={props.id}
                className={
                    'step' +
                    (props.isOpen || props.isConfirmed ? '' : ' step-closed') +
                    (props.isConfirmed ? ' step-confirmed' : '') +
                    (props.isConfirmed && currentStep != constants.steps.length - 1
                        ? ' mobile-hide'
                        : '') +
                    (isInsuranceLoading ? ' step-disabled' : '') +
                    (props.isConfirmed &&
                    props.id == 'treatments' &&
                    props.confirmedSelection == null
                        ? ' hidden'
                        : '')
                }
                data-element-id={
                    props.isOpen ? 'X_X_LensPanel_' + labels.stepAnalyticsName[currentStep] : null
                }
            >
                {props.config &&
                    props.config.brand &&
                    props.config.brand == 'costa' &&
                    isMobile &&
                    props.isOpen &&
                    !props.isConfirmed &&
                    props.handleBackClick && (
                        <a className="step-back-link" onClick={props.handleBackClick}>
                            {labels.backToPreviousStep}
                        </a>
                    )}
                {!props.isConfirmed && !props.isLearnMore ? (
                    <div
                        className="step-title"
                        style={!props.isOpen ? { opacity: getTitleOpacity() } : {}}
                    >
                        {treatmentStepTitle}
                        {props.isOpen && props.tooltipContent ? (
                            <>
                                <a
                                    className="rxc-tooltip-icon"
                                    data-for="scrollContent"
                                    data-tip
                                    data-iscapture="true"
                                    data-event="click scroll"
                                    data-analytics_available_call="1"
                                    tabIndex="0"
                                    onFocus={e => ReactTooltip.show(e.target)}
                                >
                                    <div>i</div>
                                </a>
                                <ReactTooltip
                                    ref={props.tooltipRef}
                                    id="scrollContent"
                                    type="light"
                                    effect="solid"
                                    className="rxc-tooltip"
                                >
                                    {props.tooltipContent}
                                </ReactTooltip>
                            </>
                        ) : null}
                    </div>
                ) : null}

                {props.isOpen && props.hasLearnMore ? (
                    <div className="step-learn-more">
                        {props.handleLearnMore ? (
                            <GenericButton
                                className="border-button"
                                handleClick={() => {
                                    props.handleLearnMore();
                                }}
                                title="Learn more"
                                dataElementId={
                                    'X_X_LensPanel_' +
                                    labels.stepAnalyticsName[currentStep] +
                                    '-LearnMoreOpen'
                                }
                                tabIndex={isAnyModalOpen ? '-1' : '0'}
                                disabled={isInsuranceLoading}
                            >
                                {labels.learnMore}
                            </GenericButton>
                        ) : null}
                    </div>
                ) : null}

                {props.isOpen && !props.isConfirmed ? (
                    <div className="step-content">{props.children}</div>
                ) : null}

                {props.isConfirmed ? (
                    <>
                        <IconButton
                            tabIndex={isAnyModalOpen ? '-1' : '0'}
                            className="step-edit-button"
                            onClick={!isInsuranceLoading ? props.handleEdit : null}
                            disabled={isInsuranceLoading}
                            dataElementId={
                                'X_X_LensPanel_' + labels.stepAnalyticsName[currentStep] + '-Back'
                            }
                            dataDescription={props.id}
                        />
                        <div className="step-confirmed-container">
                            <div className="step-confirmed-title">
                                {labels.steps[props.id].confirmedTitle}
                            </div>
                            <div className="step-confirmed-selection">
                                {props.confirmedSelection}
                            </div>
                        </div>
                        {props.id == 'thickness' && baseLensPackage !== null && (
                            <Price
                                value={
                                    isGVP && !isInsuranceEnabled
                                        ? parseFloat(props.config.data.frame.listPrice) +
                                          parseFloat(baseLensPackage.lensPackage.listPrice)
                                        : baseLensPackage.lensPackage.listPrice
                                }
                                discount={
                                    isGVP && !isInsuranceEnabled
                                        ? parseFloat(props.config.data.frame.listPrice) +
                                          parseFloat(baseLensPackage.lensPackage.listPrice) -
                                          (parseFloat(baseLensPackage.frame.offerPrice) +
                                              parseFloat(baseLensPackage.lensPackage.offerPrice))
                                        : isInsuranceEnabled
                                        ? baseLensPackage.lensPackage.insPrice !== null
                                            ? parseFloat(baseLensPackage.lensPackage.listPrice) -
                                              parseFloat(baseLensPackage.lensPackage.insPrice)
                                            : 0
                                        : parseFloat(baseLensPackage.lensPackage.listPrice) -
                                          parseFloat(baseLensPackage.lensPackage.offerPrice)
                                }
                                isInsuranceEnabled={isInsuranceEnabled}
                                isInsuranceLoading={isInsuranceLoading}
                            />
                        )}
                        {props.id == 'treatments' &&
                            baseLensPackage !== null &&
                            selectedPackage !== null && (
                                <Price
                                    value={
                                        isGVP && !isInsuranceEnabled
                                            ? parseFloat(selectedPackage.frame.offerPrice) +
                                              parseFloat(selectedPackage.lensPackage.offerPrice)
                                            : isInsuranceEnabled
                                            ? baseLensPackage.lensPackage.insPrice !== null &&
                                              selectedPackage.lensPackage.insPrice !== null
                                                ? parseFloat(selectedPackage.lensPackage.insPrice) -
                                                  parseFloat(baseLensPackage.lensPackage.insPrice)
                                                : parseFloat(
                                                      selectedPackage.lensPackage.listPrice
                                                  ) -
                                                  parseFloat(baseLensPackage.lensPackage.listPrice)
                                            : parseFloat(selectedPackage.lensPackage.offerPrice) -
                                              parseFloat(baseLensPackage.lensPackage.offerPrice)
                                    }
                                    isGVPPrice={isGVP && !isInsuranceEnabled}
                                    isTreatmentRecapPrice={true}
                                    isInsuranceEnabled={isInsuranceEnabled}
                                    isInsuranceLoading={isInsuranceLoading}
                                />
                            )}
                        {props.id == 'type' &&
                            selectedPrescriptionObject &&
                            (!props.hasPrescriptionStep ||
                                Object.keys(labels.steps).indexOf('prescription') !==
                                    currentStep) && (
                                <>
                                    <a
                                        href="#"
                                        className="lc-link prescription-edit"
                                        aria-label="Edit prescription data"
                                        tabIndex="0"
                                        data-for="prescriptionContent"
                                        data-tip="prescription-tooltip"
                                        data-iscapture="true"
                                        data-event="mouseenter"
                                        data-event-off="mouseleave scroll"
                                        onClick={
                                            !isInsuranceLoading
                                                ? props.hasPrescriptionStep
                                                    ? props.handleEditPrescription
                                                    : props.handleEdit
                                                : null
                                        }
                                    >
                                        {labels.prescription.editLabel}
                                    </a>
                                    {props.tooltipContent && (
                                        <ReactTooltip
                                            id="prescriptionContent"
                                            type="light"
                                            effect="solid"
                                            className="rx-tooltip"
                                            place="bottom"
                                        >
                                            {props.tooltipContent}
                                        </ReactTooltip>
                                    )}
                                </>
                            )}
                    </>
                ) : null}
            </div>
        </>
    ) : null;
};

export default Step;
